import React from 'react';

const Filter = ({ activeFilter, onFilterChange }) => {
  const filters = [
    { value: 'all', label: 'All' },
    { value: 'photography', label: 'Photography' },
    { value: 'writing', label: 'Writing' },
    { value: 'social-media', label: 'Social Media' },
  ];

  return (
    <div className="flex flex-wrap justify-center gap-3 md:gap-4 mb-12 md:mb-16">
      {filters.map((filter) => (
        <button
          key={filter.value}
          onClick={() => onFilterChange(filter.value)}
          className={`px-5 md:px-7 py-3 md:py-3.5 rounded-sm font-body font-semibold transition-all duration-400 text-sm md:text-base ${
            activeFilter === filter.value
              ? 'bg-accent text-white shadow-soft-lg scale-105'
              : 'bg-white text-secondary hover:bg-accent-light border-2 border-gray-200 hover:border-accent hover:scale-105'
          }`}
        >
          {filter.label}
        </button>
      ))}
    </div>
  );
};

export default Filter;
